import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import {DateUtils} from '../../utils/date.utils';


@Pipe({
  name: 'advancedTreeFilter',
})
export class AdvancedTreeFilterPipe implements PipeTransform {
  datePipe = new DatePipe('en-US');

  transform(items: any[], searchParam: string, searchValue?: any, match?): any {
    if (!items) {
      return [];
    } else if (!searchParam.length) {
      return items;
    } else {
      const looper = (filterParams, accumulator) => {
        return filterParams.reduce((res, val) => {
          return res.filter((item) => {
            const checkValue = (val.type === 'number') ? Number(item[val.searchKey]) :
              (val.type === 'date') ?
                DateUtils.getLocalDateFormat(item[val.searchKey].split(',')[0]) :
                item[val.searchKey] ;
            const minValue = (val.type === 'number') ?
              Number(val.startValue) : (val.type === 'date') ?
                DateUtils.getLocalDateFormat(val.startValue) :
                String(val.startValue).toLowerCase() ;
            const maxValue = (val.endValue !== '' ) ? (val.type === 'number') ?
              Number(val.endValue) : (val.type === 'date') ?
                DateUtils.getLocalDateFormat(val.endValue) :
                String(val.endValue).toLowerCase() : '' ;
            if (val.searchType === 'equals') {
              if (val.type === 'string') {
                return String(checkValue).toLowerCase().includes(String(minValue).toLowerCase());
              } else {
                return (checkValue === minValue);
              }
            } else if (val.searchType === 'greater') {
              return (val.type === 'date') ? new Date(checkValue) > new Date(minValue) : checkValue > minValue;
            } else if (val.searchType === 'lesser') {
              return (val.type === 'date') ? new Date(checkValue) < new Date(minValue) : checkValue < minValue;
            } else if (val.searchType === 'between') {
              return (val.type === 'date') ?
                (new Date(checkValue) >= new Date(minValue) &&
                  new Date(checkValue) <= new Date(maxValue)) :
                (checkValue >= minValue && checkValue <= maxValue);
            }
          });
        }, accumulator);
      };
      return looper(searchParam, items);
    }
  }
}
